import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";
import { ClinicalLibraryReadDto } from "functions/api/library/interface";
import { getThisAndParentHierarchies } from "functions/getParentHierarchies";
import { getHierarchyTlfType } from "./getHierarchyTlfType";
import { ClinicalLibraryTemplates, mergeClinicalLibraryData } from "./mergeClinicalLibraryData";

/**
 * Collects clinical-library data for a hierarchy and its same-TLF-type ancestors.
 *
 * @param currentHierarchy - Hierarchy whose inherited library data is being requested.
 * @param hierarchyNodes - Available hierarchy nodes used to resolve the ancestor chain.
 * @param clinicalLibraries - Clinical libraries keyed by the hierarchy that owns each library.
 * @returns The merged clinical-library data, with the current hierarchy taking precedence.
 */
export const getClinicalLibraryData = (
  currentHierarchy: HierarchyReadDto,
  hierarchyNodes: HierarchyReadDto[],
  clinicalLibraries: Record<string, ClinicalLibraryReadDto>,
): ClinicalLibraryTemplates => {
  const currentTlfType = getHierarchyTlfType(currentHierarchy.level);

  return [
    currentHierarchy,
    ...getThisAndParentHierarchies(currentHierarchy.parentId, hierarchyNodes),
  ].reduce<ClinicalLibraryTemplates>(
    (clinicalData, parent) => {
      const clinicalLibrary = clinicalLibraries[parent.id];

      return currentTlfType === getHierarchyTlfType(parent.level) && clinicalLibrary
        ? mergeClinicalLibraryData(clinicalData, clinicalLibrary)
        : clinicalData;
    },
    {
      clinicalDatasets: [],
      clinicalCodeLists: [],
      clinicalValueLists: [],
      clinicalComments: [],
      clinicalMethods: [],
      clinicalWhereClauses: [],
    },
  );
};
